import React from "react";
import { FiCalendar, FiExternalLink, FiMapPin } from "react-icons/fi";
import Navbar2 from "../Components/Navbar2";
import { events } from "../Data/websiteUpdates";
import "./PublicCollections.css";
import "../voices/voices-public-pages.css";

export default function Events() {
  return (
    <>
      <Navbar2 />
      <main className="public-collection-page vpp-page vpp-events" data-voices-theme="dark">
        <header className="public-collection-hero container vpp-intro">
          <p className="public-collection-eyebrow">Where we’ll be</p>
          <h1>Events</h1>
          <p>Conversations, ideas, and partnerships are better in person. Meet the Antrazal team at these upcoming events.</p>
        </header>

        <section className="event-list container" aria-label="Upcoming events">
          {events.map((event) => (
            <article className="event-card" key={event.name}>
              <div className={`event-card__banner event-card__banner--${event.theme}`}>
                <span>Antrazal attending</span>
                <strong>{event.shortName}</strong>
              </div>
              <div className="event-card__content">
                <div className="event-card__status">Attending</div>
                <h2>{event.name}</h2>
                <div className="event-card__facts">
                  <span><FiCalendar aria-hidden="true" />{event.date}</span>
                  <span><FiMapPin aria-hidden="true" />{event.location}</span>
                </div>
                <p>{event.description}</p>
                <a href={event.url} target="_blank" rel="noreferrer">
                  Visit official event page <FiExternalLink aria-hidden="true" />
                </a>
              </div>
            </article>
          ))}
        </section>
      </main>
    </>
  );
}
